import React from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';
import { useTranslation } from 'react-i18next';

import { GlobalTypes } from '@modules';
import { CurrencyEnum, Currencies } from '@modules/global/types';

import style from './FeeInformer.scss';

const cn = bemCssModules(style, 'FeeInformer');

export type TFeeInformer = {
  amountSubtotal?: string;
  amountTotal?: string;
  currency?: CurrencyEnum;
  fee?: string;
  feeCurrency?: CurrencyEnum;
  operationType: string;
  currencies: Currencies;
  bordered?: boolean;
};

const FeeInformer: CustomFC<TFeeInformer> = props => {
  const {
    className,
    amountSubtotal,
    amountTotal,
    currency,
    fee,
    feeCurrency,
    operationType,
    currencies,
    bordered,
  } = props;

  const { t } = useTranslation();
  const currenciesLib = currencies.config.display_options || null;

  const getTotalDigits = (cur: GlobalTypes.FiatCurrencyEnum | GlobalTypes.CryptoCurrencyEnum) => {
    return currenciesLib[cur]?.total_digits;
  };
  const getDisplayDigits = (cur: GlobalTypes.FiatCurrencyEnum | GlobalTypes.CryptoCurrencyEnum) => {
    return currenciesLib[cur]?.display_digits;
  };

  return fee && currenciesLib && operationType !== CONST.operations.deposit ? (
    <div className={cn({ bordered }, [className])}>
      <div className={cn('item')}>
        <span className={cn('cost')}>
          {operationType === CONST.operations.buy ? t('informer.cost') : t('informer.amount')}
          &nbsp;
          <span className={cn('value')}>
            {currency && amountSubtotal
              ? correctingTrailingNumbers(
                  amountSubtotal,
                  getDisplayDigits(currency),
                  getTotalDigits(currency)
                )
              : null}{' '}
            {currency}
          </span>
        </span>
      </div>
      <div className={cn('item')}>
        <span className={cn('bull')}>&bull;</span>
        <span className={cn('fee')}>
          {t('informer.fee')}&nbsp;
          <span className={cn('value')}>
            {fee && feeCurrency
              ? correctingTrailingNumbers(
                  fee,
                  getDisplayDigits(feeCurrency),
                  getTotalDigits(feeCurrency)
                )
              : '--:'}{' '}
            {feeCurrency || '--'}
          </span>
        </span>
      </div>
      <div className={cn('item')}>
        <span className={cn('bull')}>&bull;</span>
        <span className={cn('total')}>
          {t('informer.total')}&nbsp;
          <span className={cn('value')}>
            {amountTotal && currency
              ? correctingTrailingNumbers(
                  amountTotal,
                  getDisplayDigits(currency),
                  getTotalDigits(currency)
                )
              : '--'}{' '}
            {currency}
          </span>
        </span>
      </div>
    </div>
  ) : null;
};

export default FeeInformer;
